import { ClariahLink } from "components/ClariahLink";
import { EVENT_TYPE, PAGE_TYPE } from "shared/constants";
import { formatDatePreview } from "shared/formatDate";
import { SrcSet } from "components/SrcSet";
import { translate } from "shared/translate";
import { useRouter } from "next/router";
import cx from "classnames";
import styles from "./Card.module.css";

export const Card = ({
  date,
  description,
  endDate,
  featured,
  href,
  type,
  src,
  title,
}) => {
  const { locale } = useRouter();

  const label =
    type && type !== PAGE_TYPE ? translate(type.toUpperCase(), locale) : null;

  return (
    <ClariahLink
      className={cx(styles.container, { [styles.featured]: featured })}
      href={href}
      type={type}
    >
      <div className={styles.imageContainer}>
        {label &&
          (type === EVENT_TYPE ? (
            <EventLabel
              startDate={formatDatePreview(date, locale)}
              endDate={formatDatePreview(endDate, locale)}
            />
          ) : (
            <div className={styles.label}>{label}</div>
          ))}
        {src && (
          <SrcSet
            alt={title}
            src={src}
            sizes={[
              { minWidth: 1024, width: featured ? 870 : 420, ratio: 16 / 9 },
              { minWidth: 900, width: 300, ratio: 16 / 9 },
              { minWidth: 768, width: 265, ratio: 16 / 9 },
              { minWidth: 700, width: 768, ratio: 16 / 9 },
              { minWidth: 600, width: 660, ratio: 16 / 9 },
              { minWidth: 500, width: 560, ratio: 16 / 9 },
              { minWidth: 400, width: 460, ratio: 16 / 9 },
              { minWidth: 345, width: 360, ratio: 16 / 9 },
              { minWidth: 1, width: 345, ratio: 16 / 9 },
            ]}
          />
        )}
      </div>

      <div className={styles.content}>
        {label && <div className={styles.label}>{label}</div>}
        <h2>{title}</h2>
        {description && (
          <p>
            {description.length > 140
              ? `${description.substring(0, 140)}...`
              : description}
          </p>
        )}
      </div>
    </ClariahLink>
  );
};

const EventLabel = ({ startDate, endDate }) => {
  const dates = [];
  if (startDate) dates.push(startDate);
  if (endDate) dates.push(endDate);

  return (
    <div className={styles.eventLabel}>
      {dates.map((date, index) => (
        <div key={index} className={styles.date}>
          {date.map((v, i) => (
            <div key={i}>{v}</div>
          ))}
        </div>
      ))}
    </div>
  );
};
